import React from "react";

interface NewProjectDialogProps {
  isOpen: boolean;
  onSaveAndNew: () => void;
  onDiscardAndNew: () => void;
  onCancel: () => void;
  projectName?: string;
  hasUnsavedChanges: boolean;
}

export const NewProjectDialog: React.FC<NewProjectDialogProps> = ({
  isOpen,
  onSaveAndNew,
  onDiscardAndNew,
  onCancel,
  projectName = "Current Project",
  hasUnsavedChanges,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-800 rounded-lg shadow-xl w-[480px] max-w-[90vw] border border-gray-700">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          <div className="flex items-center gap-2">
            <h2 className="text-lg font-semibold text-white">
              Create New Project
            </h2>
          </div>
          <button
            onClick={onCancel}
            className="text-gray-400 hover:text-white transition-colors"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          {hasUnsavedChanges ? (
            <>
              <p className="text-gray-300 text-sm">
                Would you like to save your current work before creating a new
                project?
              </p>
            </>
          ) : (
            <div className="p-4 bg-blue-900/30 border border-blue-500 rounded text-blue-200">
              <div className="flex items-start gap-3">
                <span className="text-2xl">ℹ️</span>
                <div>
                  <p className="text-sm">
                    This will create a new blank project. Your current work will
                    be cleared.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer Buttons */}
        <div className="flex justify-end gap-3 p-4 border-t border-gray-700">
          {hasUnsavedChanges ? (
            <>
              {/* Show Save & New and Discard & New if there are unsaved changes */}
              <button
                onClick={onCancel}
                className="px-4 py-2 bg-gray-600 hover:bg-gray-500 text-white rounded transition-colors"
              >
                Cancel
              </button>

              <button
                onClick={onDiscardAndNew}
                className="px-4 py-2 bg-red-600 hover:bg-red-500 text-white rounded transition-colors flex items-center gap-2"
              >
                <span>Discard & New</span>
              </button>

              <button
                onClick={onSaveAndNew}
                className="px-4 py-2 bg-green-600 hover:bg-green-500 text-white rounded transition-colors flex items-center gap-2"
              >
                <span>Save & New</span>
              </button>
            </>
          ) : (
            <>
              {/* No unsaved changes - just show Create New */}
              <button
                onClick={onCancel}
                className="px-4 py-2 bg-gray-600 hover:bg-gray-500 text-white rounded transition-colors"
              >
                Cancel
              </button>

              <button
                onClick={onDiscardAndNew}
                className="px-4 py-2 bg-blue-600 hover:bg-blue-500 text-white rounded transition-colors flex items-center gap-2"
              >
                <span>✨</span>
                <span>Create New</span>
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
